var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SearchInput',{attrs:{"placeholder":"Search for shipments by tracking reference","value":_vm.searchTerm},on:{"changeValue":_vm.setSearchTerm,"clear":_vm.onClearSearch}})
}
var staticRenderFns = []

export { render, staticRenderFns }